import React from 'react'
import styles from './styles.module.css'
import cn from 'classnames'

export default function Input({ label, error, className, inputName, money, labelStyle, required, highlight, ...props }) {

  const inputClassObject = cn(
    styles.input, inputName,
    { [styles.error]: error }
  )

  const inputClassObjectLabel = cn(
    styles.label, className
  )

  return (
    // <div className={!props.inputLineLabel ? styles.marginTop : styles.marginTopInputsLine}> // не надо так делать, ведь уже много где применялся этот компонент без этого дива
    <label className={props.name !== "folderName" ? inputClassObjectLabel : styles.labelForMethodOffice}>
      <p className={cn({ [styles.greenLabel]: highlight })} style={labelStyle}>{label}{required && <span className={styles.requiredMark}> *</span>}</p>
      <input className={inputClassObject} {...props} />
      {!!error &&
        <>
          <p className={styles.errorText}>{error}</p>
        </>
      }
    </label>
    // </div>

  )
}
